<section class="user-notifications" (click)="$event.stopPropagation()" role="dialog" aria-label="Centro de notificaciones">

  <!-- ============= HEADER ============= -->
  <header class="un-header">
    <div class="un-header__title">
      <h3>Notificaciones</h3>
      <span class="un-header__badge" *ngIf="unreadCount() > 0" aria-live="polite">
        {{ unreadCountLabel() }} sin leer
      </span>
      <span class="un-header__badge un-header__badge--muted" *ngIf="unreadCount() === 0 && notifications.length > 0">
        Todo al día
      </span>
    </div>

    <div class="un-header__actions">
      <button type="button" class="un-icon-btn"
        [matTooltip]="soundEnabled ? 'Silenciar sonido de notificaciones' : 'Activar sonido de notificaciones'"
        [attr.aria-label]="soundEnabled ? 'Silenciar sonido de notificaciones' : 'Activar sonido de notificaciones'"
        [attr.aria-pressed]="!soundEnabled"
        (click)="toggleSound()">
        <i class="fas" [ngClass]="soundEnabled ? 'fa-volume-up' : 'fa-volume-mute'"></i>
      </button>
      <button type="button" class="un-icon-btn" matTooltip="Actualizar"
        aria-label="Actualizar notificaciones"
        (click)="refreshNotifications()" [disabled]="loading || loadingMore">
        <i class="fas fa-sync-alt" [class.fa-spin]="loading && !loadingMore"></i>
      </button>
      <button type="button" class="un-icon-btn un-icon-btn--accent" matTooltip="Marcar todas como leídas"
        aria-label="Marcar todas como leídas"
        (click)="markAllAsRead()"
        [disabled]="actionInProgress || loading || unreadCount() === 0">
        <i class="fas fa-check-double"></i>
      </button>
    </div>
  </header>

  <!-- ============= ACTIVAR ALERTAS ============= -->
  <div class="un-alerts-card" *ngIf="showNotificationAlertsActivation()" role="status">
    <div class="un-alerts-card__icon">
      <i class="fas fa-bell-slash"></i>
    </div>
    <div class="un-alerts-card__copy">
      <strong>Alertas apagadas</strong>
      <span>Enciéndelas para escuchar avisos de nuevas solicitudes.</span>
    </div>
    <button type="button" class="un-alerts-card__action"
      (click)="activateNotificationAlerts()"
      [disabled]="enablingBrowserNotifications">
      <i class="fas" [ngClass]="enablingBrowserNotifications ? 'fa-spinner fa-spin' : 'fa-bell'"></i>
      <span>{{ enablingBrowserNotifications ? 'Encendiendo' : 'Encender alertas' }}</span>
    </button>
  </div>

  <div class="un-alerts-card un-alerts-card--blocked" *ngIf="showBrowserNotificationBlocked()" role="status">
    <div class="un-alerts-card__icon">
      <i class="fas fa-bell-slash"></i>
    </div>
    <div class="un-alerts-card__copy">
      <strong>Alertas bloqueadas</strong>
      <span>Permítelas en el navegador para escuchar avisos.</span>
    </div>
    <button type="button" class="un-alerts-card__action un-alerts-card__action--light"
      (click)="openPermissionGuide()"
      aria-label="Abrir guía paso a paso para reactivar notificaciones">
      <i class="fas fa-hand-pointer"></i>
      <span>Guíame paso a paso</span>
    </button>
  </div>

  <div class="un-banner un-banner--warning" *ngIf="showBrowserNotificationUnsupported()" role="status">
    <i class="fas fa-exclamation-triangle"></i>
    <span>Este navegador no permite alertas en tiempo real. Puedes revisar tus notificaciones aquí.</span>
  </div>

  <!-- ============= FILTROS ============= -->
  <div class="un-filters" role="tablist" aria-label="Filtros de notificaciones">
    <button type="button" role="tab" [attr.aria-selected]="activeFilter === 'ALL'"
      [class.is-active]="activeFilter === 'ALL'" (click)="setFilter('ALL')">
      Todas
    </button>
    <button type="button" role="tab" [attr.aria-selected]="activeFilter === 'UNREAD'"
      [class.is-active]="activeFilter === 'UNREAD'" (click)="setFilter('UNREAD')">
      No leídas
      <span class="un-filters__count" *ngIf="unreadCount() > 0 && activeFilter !== 'UNREAD'">
        {{ unreadCountLabel() }}
      </span>
    </button>
    <button type="button" role="tab" [attr.aria-selected]="activeFilter === 'READ'"
      [class.is-active]="activeFilter === 'READ'" (click)="setFilter('READ')">
      Leídas
    </button>
  </div>

  <!-- ============= ERROR ============= -->
  <div class="un-banner un-banner--error" *ngIf="errorMessage" role="alert">
    <i class="fas fa-exclamation-circle"></i>
    <span>{{ errorMessage }}</span>
  </div>

  <!-- ============= LOADING (skeleton) =============
       Solo se muestra en la carga inicial (sin datos previos).
       En refrescos sobre datos existentes, la lista se mantiene
       visible y el botón de refresh del header gira como indicador. -->
  <div class="un-skeleton"
    *ngIf="loading && !loadingMore && !errorMessage && notifications.length === 0"
    aria-hidden="true">
    <div class="un-skeleton__card" *ngFor="let _ of [1,2,3]">
      <div class="un-skeleton__avatar"></div>
      <div class="un-skeleton__lines">
        <div class="un-skeleton__line un-skeleton__line--title"></div>
        <div class="un-skeleton__line"></div>
        <div class="un-skeleton__line un-skeleton__line--short"></div>
      </div>
    </div>
  </div>

  <!-- ============= EMPTY STATE ============= -->
  <div class="un-empty" *ngIf="!loading && !errorMessage && notifications.length === 0">
    <div class="un-empty__icon">
      <i class="far fa-bell-slash"></i>
    </div>
    <p class="un-empty__title">
      <ng-container *ngIf="activeFilter === 'ALL'">No tienes notificaciones</ng-container>
      <ng-container *ngIf="activeFilter === 'UNREAD'">¡Estás al día!</ng-container>
      <ng-container *ngIf="activeFilter === 'READ'">Aún no hay notificaciones leídas</ng-container>
    </p>
    <p class="un-empty__hint">
      <ng-container *ngIf="activeFilter === 'ALL'">Te avisaremos aquí cuando algo importante ocurra.</ng-container>
      <ng-container *ngIf="activeFilter === 'UNREAD'">No hay notificaciones pendientes por revisar.</ng-container>
      <ng-container *ngIf="activeFilter === 'READ'">Cuando leas tus notificaciones, las verás aquí.</ng-container>
    </p>
  </div>

  <!-- ============= LISTA ============= -->
  <div class="un-list" *ngIf="notifications.length > 0">
    <article class="un-card" role="button" tabindex="0"
      *ngFor="let notification of notifications; trackBy: trackByNotification"
      [class.is-unread]="notification.status === 'UNREAD'"
      [class.is-deleting]="isDeleting(notification)"
      (click)="openNotification(notification)"
      (keyup.enter)="openNotification(notification)"
      [attr.aria-label]="(notification.status === 'UNREAD' ? 'No leída: ' : '') + notification.title">

      <div class="un-card__icon" [attr.data-type]="notification.notificationType">
        <i class="fas" [ngClass]="iconForType(notification.notificationType)"></i>
        <span class="un-card__dot" *ngIf="notification.status === 'UNREAD'" aria-hidden="true"></span>
      </div>

      <div class="un-card__body">
        <div class="un-card__row">
          <h4 class="un-card__title">{{ notification.title }}</h4>
          <time class="un-card__time" [attr.datetime]="notification.createdAt"
            [matTooltip]="formatDate(notification.createdAt)">
            {{ relativeDate(notification.createdAt) }}
          </time>
        </div>

        <p class="un-card__text">{{ notification.body }}</p>

        <div class="un-card__meta">
          <button type="button" class="un-icon-btn un-icon-btn--ghost"
            matTooltip="Eliminar"
            aria-label="Eliminar notificación"
            (click)="deleteNotification(notification, $event)"
            [disabled]="isDeleting(notification)">
            <i class="fas" [ngClass]="isDeleting(notification) ? 'fa-spinner fa-spin' : 'fa-trash-alt'"></i>
          </button>
        </div>
      </div>
    </article>

    <button type="button" class="un-load-more" *ngIf="hasNextPage()"
      (click)="loadMore()" [disabled]="loadingMore">
      <i class="fas" [ngClass]="loadingMore ? 'fa-spinner fa-spin' : 'fa-chevron-down'"></i>
      <span>{{ loadingMore ? 'Cargando…' : 'Ver más' }}</span>
    </button>
  </div>

</section>
